var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc"},[_c('el-image',{staticClass:"doc-img",attrs:{"lazy":true,"src":_vm.img,"fit":"contain"},scopedSlots:_vm._u([{key:"error",fn:function(){return [_c('div')]},proxy:true}])}),_c('div',{staticClass:"doc-footer"},[_vm._v(_vm._s(_vm.duration))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }